import { Input } from "@/components/ui/input";
import { previewMinutes, parseDecimalInput } from "@/lib/format";
import { fmtMinutes } from "@/lib/format";
import { cn } from "@/lib/utils";

/** Talinput med norsk desimal-komma. */
export const DecimalInput = ({ value, onChange, className, ...props }) => (
  <Input
    inputMode="decimal"
    autoComplete="off"
    value={value}
    onChange={(e) => onChange(e.target.value)}
    className={cn("tabular", className)}
    {...props}
  />
);

export const HoursHint = ({ value, testId = "hours-hint" }) => {
  const n = parseDecimalInput(value);
  if (value === "" || value === null || value === undefined) {
    return <p className="text-xs text-muted-foreground" data-testid={testId}>Skriv timar med komma, t.d. 1,5</p>;
  }
  if (Number.isNaN(n) || n <= 0) {
    return <p className="text-xs text-destructive" data-testid={testId}>Ugyldig tal. Bruk t.d. 1,5 (ikkje negativt).</p>;
  }
  if (n > 24) {
    return <p className="text-xs text-destructive" data-testid={testId}>Maks 24 timar per registrering.</p>;
  }
  return <p className="text-xs text-muted-foreground" data-testid={testId}>= {fmtMinutes(previewMinutes(value))}</p>;
};
